import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

export function useCarrierCompanyMembers() {
  const { company } = useRoleContext();

  const url =
    company != null ? `/companies/${company.id}/carrier-members` : null;

  const { data, loading, error } = useSwrFetch<CompanyMember[]>({
    url,
    errorMessage: "Failed to fetch carrier company members",
  });

  return {
    members: data ?? [],
    error,
    loading,
  };
}
